class ComprobanteEgresoInputPipe {

  getName() {
    return 'egreso';
  }

  apply(data, comprobante) {
    const cfdiUiid = data.Complemento?.TimbreFiscalDigital?.UUID;

    if (comprobante.isEgreso() && (data.TipoDeComprobante !== 'I' &&  data.TipoDeComprobante !== 'E')) {
      throw new Error('El comprobante no es de tipo ingreso, solo comprobantes de ingreso pueden tener asociado un comprobante de egreso.');
    }

    if (comprobante.isEgreso() && cfdiUiid && data.TipoDeComprobante === 'I') {
      data.CfdiRelacionados = {
        TipoRelacion: '01',
        CfdiRelacionado: [
          {
            UUID: cfdiUiid
          }
        ]
      }
    }

    return data;
  }

}

export default ComprobanteEgresoInputPipe;